/* Vaelor: working quantity + add to cart on product cards.
   The theme ships a "quick add" control that never finishes loading, so the
   arrows do nothing. This replaces it with a stepper capped at real stock and
   an Add to cart button that posts to the cart and refreshes the cart drawer. */
(function () {
  var MAX_FALLBACK = 99;

  function build(host) {
    var input = host.querySelector('input[data-quantity-variant-id]');
    if (!input) return false;
    var variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) return false;

    var max = parseInt(input.getAttribute('max'), 10);
    if (isNaN(max) || max < 1) max = MAX_FALLBACK;
    var low = max < 6 ? max : 0;

    host.innerHTML =
      '<div class="vpqa" data-vpqa data-variant="' + variantId + '" data-max="' + max + '">' +
        '<div class="vpqa__qty">' +
          '<button type="button" data-vpqa-step="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" value="1" min="1" max="' + max + '" step="1" inputmode="numeric" data-vpqa-input aria-label="Quantity">' +
          '<button type="button" data-vpqa-step="1" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="vpqa__add" data-vpqa-add>Add to cart</button>' +
        (low ? '<p class="vpqa__left">Only ' + low + ' left</p>' : '') +
        '<p class="vpqa__msg" data-vpqa-msg hidden></p>' +
      '</div>';
    host.classList.remove('hidden-during-load');
    host.classList.add('vpqa-ready');
    host.removeAttribute('hidden');
    return true;
  }

  function buildOptionsLink(wrap) {
    var card = wrap.closest('.card-wrapper, .product-card-wrapper, .sbp-grid__item');
    var link = card ? card.querySelector('a[href*="/products/"]') : null;
    if (!link) return;
    wrap.innerHTML = '<a class="vpqa__options" href="' + link.getAttribute('href') + '">Choose options</a>';
    wrap.classList.add('vpqa-ready');
  }

  function scan(root) {
    (root || document).querySelectorAll('quick-add-bulk:not(.vpqa-ready)').forEach(function (host) {
      build(host);
    });
    (root || document).querySelectorAll('.quick-add:not(.vpqa-ready)').forEach(function (wrap) {
      if (wrap.querySelector('quick-add-bulk')) { wrap.classList.add('vpqa-ready'); return; }
      if (wrap.querySelector('quick-add-modal')) buildOptionsLink(wrap);
    });
  }

  function clamp(box, value) {
    var max = parseInt(box.getAttribute('data-max'), 10) || MAX_FALLBACK;
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > max) n = max;
    return n;
  }

  function setMsg(box, text, isError) {
    var msg = box.querySelector('[data-vpqa-msg]');
    if (!msg) return;
    if (!text) { msg.hidden = true; msg.textContent = ''; return; }
    msg.hidden = false;
    msg.textContent = text;
    msg.className = 'vpqa__msg' + (isError ? ' vpqa__msg--error' : '');
  }

  function refreshCart(data) {
    if (!data || !data.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      try { drawer.renderContents(data); return; } catch (e) {}
    }
    Object.keys(data.sections).forEach(function (key) {
      var parsed = new DOMParser().parseFromString(data.sections[key], 'text/html');
      var incoming = parsed.getElementById('shopify-section-' + key) || parsed.body.firstElementChild;
      var current = document.getElementById('shopify-section-' + key) || document.getElementById(key);
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    });
  }

  function add(box, button) {
    var id = Number(box.getAttribute('data-variant'));
    var input = box.querySelector('[data-vpqa-input]');
    var qty = clamp(box, input ? input.value : 1);
    if (!id) return;

    button.disabled = true;
    button.textContent = 'Adding…';
    setMsg(box, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: qty }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (r) {
      if (!r.ok) {
        setMsg(box, r.data.description || r.data.message || 'Could not add that item.', true);
        button.textContent = 'Add to cart';
        button.disabled = false;
        return;
      }
      refreshCart(r.data);
      button.textContent = 'Added ✓';
      setMsg(box, qty > 1 ? qty + ' added to cart' : 'Added to cart');
      setTimeout(function () {
        button.textContent = 'Add to cart';
        button.disabled = false;
        setMsg(box, '');
      }, 2500);
    }).catch(function () {
      setMsg(box, 'Network problem. Please try again.', true);
      button.textContent = 'Add to cart';
      button.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-vpqa-step]');
    if (step) {
      e.preventDefault();
      var box = step.closest('[data-vpqa]');
      var input = box.querySelector('[data-vpqa-input]');
      var next = clamp(box, Number(input.value) + Number(step.getAttribute('data-vpqa-step')));
      var max = parseInt(box.getAttribute('data-max'), 10) || MAX_FALLBACK;
      input.value = next;
      setMsg(box, next >= max && max < MAX_FALLBACK ? 'That is all we have in stock' : '');
      return;
    }
    var btn = e.target.closest('[data-vpqa-add]');
    if (btn) {
      e.preventDefault();
      var wrap = btn.closest('[data-vpqa]');
      if (wrap) add(wrap, btn);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-vpqa-input]');
    if (!input) return;
    var box = input.closest('[data-vpqa]');
    input.value = clamp(box, input.value);
  });

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
